export default __webpack_public_path__ + "img/k6cc.5f45913a.jpg";